/**
 * Flat log view - displays logs in a traditional table format
 */

import type { LogEvent } from '@/types/dashboard';
import { getLogEventKey } from './utils';
import { LogTableShell, LogRow } from './LogTable';
import { useRowExpansion } from './useRowExpansion';

interface FlatLogViewProps {
  events: LogEvent[];
}

/**
 * Displays logs in a flat table format with expandable rows
 *
 * Features:
 * - Same table structure as grouped view for consistency
 * - Expandable rows for full message view
 * - Request ID and stream name in expanded view
 */
export function FlatLogView({ events }: FlatLogViewProps) {
  const { toggleRow, isExpanded } = useRowExpansion();

  return (
    <LogTableShell>
      {events.map((event, index) => {
        const rowKey = getLogEventKey(event, index);

        return (
          <LogRow
            key={rowKey}
            event={event}
            rowKey={rowKey}
            isExpanded={isExpanded(rowKey)}
            onToggle={toggleRow}
          />
        );
      })}
    </LogTableShell>
  );
}
